import { Button } from '../ui/button';
import { Card } from '../ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Trash2 } from 'lucide-react';
import { displayDate } from '../../lib/dates';

export const PayoutTable = ({ payouts, fmt, onDelete }) => (
  <Card className="hidden md:block bg-white border border-[#D1D1CD] rounded-lg shadow-sm overflow-hidden">
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow className="bg-[#F4F4F0]">
            <TableHead className="font-semibold text-[#1C1C1E]">Worker</TableHead>
            <TableHead className="font-semibold text-[#1C1C1E]">Amount</TableHead>
            <TableHead className="font-semibold text-[#1C1C1E]">Payment Date</TableHead>
            <TableHead className="font-semibold text-[#1C1C1E] hidden md:table-cell">Notes</TableHead>
            <TableHead className="font-semibold text-[#1C1C1E] text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {payouts.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} className="text-center py-8 text-[#5C5C5C]">
                No payouts recorded yet
              </TableCell>
            </TableRow>
          ) : (
            payouts.map((payout) => (
              <TableRow key={payout.id} data-testid={`payout-row-${payout.id}`}>
                <TableCell className="font-medium text-[#1C1C1E]">
                  {payout.worker_name}
                </TableCell>
                <TableCell>
                  <span className="font-semibold text-[#2E4632]">
                    {fmt(payout.amount)}
                  </span>
                </TableCell>
                <TableCell className="text-[#5C5C5C] text-sm">
                  {displayDate(payout.date)}
                </TableCell>
                <TableCell className="hidden md:table-cell text-[#5C5C5C] text-sm">
                  {payout.notes || '-'}
                </TableCell>
                <TableCell className="text-right">
                  <Button
                    variant="ghost"
                    size="icon"
                    data-testid={`delete-payout-${payout.id}`}
                    onClick={() => onDelete(payout.id)}
                    className="h-10 w-10 text-[#5C5C5C] hover:text-[#BC4749] hover:bg-[#BC4749]/10"
                  >
                    <Trash2 className="w-4 h-4" />
                  </Button>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  </Card>
);
